<template>
    <div class="view">
        <div class="imageBg">
            <img src="@/assets/join/bg.jpg" alt="" class="bg"/>
        </div>
        <div class="infoBox">
            <div class="content">
                <div class="driverInfo">
                    <div class="hearder">
                        <img src="@/assets/join/left.png" alt="">
                        <span class="title">注册信息</span>
                        <img src="@/assets/join/right.png" alt="">
                    </div>
                    <div class="formData">
                        <van-field 
                            class="formInput"
                            v-model="form.mobile" 
                            required 
                            maxlength="11"
                            label-width="48px"
                            @input="changePhone"
                            placeholder="请输入手机号"
                            label="手机号" />
                        <div class="codeInput">
                            <van-field
                                class="formInput"
                                v-model="form.code"
                                center
                                required
                                type="number"
                                maxlength="6"
                                @input="changeCode"
                                label-width="48px"
                                label="验证码"
                                placeholder="请输入验证码">
                            </van-field>
                            <div class="sendCode" @click="getCode">
                                {{ codeTips }}
                            </div>
                        </div>
                    </div>
                    <!-- 登录后展示 -->
                    <template v-if="driverInfo.mobile == form.mobile && driverId">
                        <div class="info">
                            <div class="titleBox">
                                <div class="titleLeft">
                                    <div class="line"></div>
                                    <div>个人信息</div>
                                </div>
                                <div class="titleRight" @click="toRealname">
                                    <div class="btnText">{{ driverInfo.real_status == 1 ? '重新实名' : '实名认证' }}</div>
                                    <van-icon name="arrow" />
                                </div>
                            </div>
                            <div class="contentBox">
                                <div class="infoLi">
                                    <span class="label">姓名</span>
                                    <span :class="['value', { 'placeholder': driverInfo.real_status != 1 }]">{{ driverInfo.real_status == 1 ? driverInfo.name : '内容自动识别' }}</span>
                                </div>
                                <div class="infoLi">
                                    <span class="label">身份证号</span>
                                    <span :class="['value', { 'placeholder': driverInfo.real_status != 1 }]">{{ driverInfo.real_status == 1 ? driverInfo.number : '内容自动识别' }}</span>
                                </div>
                                <template v-if="driverInfo.real_status == 1">
                                    <div class="imageList">
                                        <div class="imageLi">
                                            <van-image class="img" :src="driverInfo.idcard_front" radius="5">
                                                <template v-slot:loading>
                                                    <van-loading type="spinner" size="20" />
                                                </template>
                                            </van-image>
                                            <span>身份证人像面</span>
                                        </div>
                                        <div class="imageLi">
                                            <van-image class="img" :src="driverInfo.idcard_back" radius="5">
                                                <template v-slot:loading>
                                                    <van-loading type="spinner" size="20" />
                                                </template>
                                            </van-image>
                                            <span>身份证国徽面</span>
                                        </div>
                                        <div class="imageLi">
                                            <van-image class="img" :src="driverInfo.driver_front" radius="5">
                                                <template v-slot:loading>
                                                    <van-loading type="spinner" size="20" />
                                                </template>
                                            </van-image>
                                            <span>驾驶证主页</span>
                                        </div>
                                        <div class="imageLi">
                                            <van-image class="img" :src="driverInfo.driver_back" radius="5">
                                                <template v-slot:loading>
                                                    <van-loading type="spinner" size="20" />
                                                </template>
                                            </van-image>
                                            <span>驾驶证副页</span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        
                        <div class="info">
                            <div class="titleBox">
                                <div class="titleLeft">
                                    <div class="line"></div>
                                    <div>车辆信息</div>
                                </div>
                                <div class="titleRight" @click="toVehicle">
                                    <div class="btnText">{{ driverInfo.is_certify == 1 ? '重新认证' : '车辆认证' }}</div>
                                    <van-icon name="arrow" />
                                </div>
                            </div>
                            <div class="contentBox">
                                <div class="infoLi">
                                    <span class="label">车牌号</span>
                                    <span :class="['value', { 'placeholder': driverInfo.is_certify != 1 }]">{{ driverInfo.is_certify == 1 ? driverInfo.license : '内容自动识别' }}</span>
                                </div>
                                <template v-if="driverInfo.is_certify == 1">
                                    <div class="imageList">
                                        <div class="imageLi">
                                            <van-image class="img" :src="driverInfo.vehicle_front" radius="5">
                                                <template v-slot:loading>
                                                    <van-loading type="spinner" size="20" />
                                                </template>
                                            </van-image>
                                            <span>行驶证</span>
                                        </div>
                                        <div class="imageLi">
                                            <van-image class="img" :src="driverInfo.pic" radius="5">
                                                <template v-slot:loading>
                                                    <van-loading type="spinner" size="20" />
                                                </template>
                                            </van-image>
                                            <span>车身车牌照</span>
                                        </div>
                                        <template v-if="false">
                                            <div class="imageLi">
                                                <van-image class="img" :src="driverInfo.insurance_url ? driverInfo.insurance_url : ''" radius="5">
                                                    <template v-slot:loading>
                                                        <van-loading type="spinner" size="20" />
                                                    </template>
                                                </van-image>
                                                <span>交强险照片</span>
                                            </div>
                                            <div class="imageLi">
                                                <van-image class="img" :src="driverInfo.commercial_url ? driverInfo.commercial_url : ''" radius="5">
                                                    <template v-slot:loading>
                                                        <van-loading type="spinner" size="20" />
                                                    </template>
                                                </van-image>
                                                <span>商业险照片</span>
                                            </div>
                                            <div class="imageLi">
                                                <van-image class="img" :src="driverInfo.trailer_url ? driverInfo.trailer_url : ''" radius="5">
                                                    <template v-slot:loading>
                                                        <van-loading type="spinner" size="20" />
                                                    </template>
                                                </van-image>
                                                <span>拖挂险照片</span>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="agreement">
                    <van-checkbox v-model="agreementCheck" shape="square" icon-size="14px" checked-color="var(--theme-color)">
                        <span class="agreementLabel">我已阅读并同意</span>
                        <span class="agreementText" @click.stop="openAgree">《加盟服务协议》</span>
                    </van-checkbox>
                </div>
                <div class="affirmBtn" @click="affirmJoin">{{ joinInfo.join_status == 2 ? '重新提交' : '立即加入' }}</div>
            </div>
        </div>
        <!-- 检测弹窗提醒 -->
        <van-dialog 
            v-model="tipsDialogVsi" 
            confirm-button-text='我知道了'
            :confirm-button-color='$themeColor'
            @confirm='tipsDialogVsi = false'>
            <div class="tipsDialogView">
                <span>{{ tipsTitle }}</span>
                <span class="tips">{{ tipsText }}</span>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import Data from '@/utils/data'
import { getQueryString, filterCompany } from '@/utils/index'
import { getCode, driverRegister, driverDetail, driverJoinInfo } from '@/apis/join'
export default {
    data(){
        return {
            company: '',
            agreementCheck: false,
            form: {
                mobile: '',
                code: ''
            },
            codeTips: '获取验证码',
            codeTime: 60,
            timer: null,
            driverId: '',   //38: 15100000001
            driverInfo: '',
            tipsDialogVsi: false,
            tipsTitle: '',
            tipsText: '',
            joinInfo: '',       //已加盟师傅详情
        }
    },
    mounted(){
        let company = getQueryString('s');
        this.company = company
        let xhost = filterCompany(company)
        if(!xhost){
            this.$notify({
                type: 'danger',
                message: '非法访问地址！'
            })
            return
        }
        Data.XHOST = xhost
        let driverId = sessionStorage.getItem('driverId')
        if(driverId){
            this.driverId = driverId
            this.getDetail()
        }
    },
    methods: {
        // 实名认证
        toRealname(){
            if(!this.joinValid()) return
            this.$router.push({
                path: '/realname',
                query: {
                    e: this.getQuery()
                }
            })
        },
        // 车辆认证
        toVehicle(){
            if(!this.joinValid()) return
            this.$router.push({
                path: '/vehicle',
                query: {
                    e: this.getQuery()
                }
            })
        },
        // 加盟认证
        affirmJoin(){
            if(!this.joinValid()) return
            if(this.driverInfo.real_status != 1){
                this.$notify({
                    type: 'danger',
                    message: '请先进行实名认证！'
                })
                return
            }
            if(this.driverInfo.is_certify != 1){
                this.$notify({
                    type: 'danger',
                    message: '请先进行车辆认证！'
                })
                return
            }
            if(!this.agreementCheck){
                this.$notify({
                    type: 'danger',
                    message: '请先阅读并同意服务协议！'
                })
                return
            }
            this.$router.push({
                path: '/service',
                query: {
                    e: this.getQuery()
                }
            })
        },
        // 获取页面携带参数
        getQuery(){
            let time = new Date().getTime()
            let paramsInfo = {
                id: this.driverId,
                time: time,
                company: this.company
            }
            let query = this.$xorEncrypt(JSON.stringify(paramsInfo))
            return query
        },
        changePhone(){
            this.form.code = ''
        },
        // 获取验证码
        getCode(){
            if(this.codeTime != 60) return
            if(this.form.mobile.length != 11){
                this.$notify({
                    type: 'danger',
                    message: '手机号错误！'
                })
                return
            }else{
                let params = {
                    mobile: this.form.mobile
                }
                getCode(params).then((res)=>{
                    if(res.data.code == 1){
                        --this.codeTime;
                        this.codeTips = `${this.codeTime}秒重新获取`
                        this.timefunc()
                    }else{
                        this.$toast(res.data.info);
                    }
                })
            }
        },
        timefunc(){
            this.timer = setInterval((e)=>{
                if(this.codeTime <= 1){
                    clearInterval(this.timer)
                    this.timer = null
                    this.codeTips = '获取验证码'
                    this.codeTime = 60
                }else{
                    --this.codeTime;
                    this.codeTips = `${this.codeTime}秒重新获取`
                }
            }, 1000)
        },
        // 输入验证码
        changeCode(e){
            if(e.length == 4 || e == 929555 || e == 898998){
                driverRegister(this.form).then((res)=>{
                    let info = res.data
                    if(info.code == 1){
                        console.log(res.data, '师傅信息')
                        let token = info.data.token;
                        this.driverId = info.data.id
                        sessionStorage.setItem('token', token);
                        sessionStorage.setItem('driverId', this.driverId);
                        this.getDetail()
                    }else{
                        this.$toast(info.info);
                    }
                })
            }
        },
        // 获取师傅信息
        getDetail(){
            let params = {
                id: this.driverId
            }
            driverDetail(params).then((res)=>{
                console.log(res, '师傅详情')
                let info = res.data.data
                if(!this.form.mobile){
                    this.form.mobile = info.mobile
                }
                this.driverInfo = info
                if(info.is_join == 1){
                    this.getDriverJoinInfo()
                }else{
                    this.joinInfo = ''
                    this.joinValid()
                }
            })
        },
        // 获取已加盟师傅详情
        getDriverJoinInfo(){
            driverJoinInfo().then((res)=>{
                this.joinInfo = res.data.data
                if(this.joinInfo.join_status == 2){
                    this.tipsTitle = '审核驳回'
                    this.tipsText = `驳回原因：${this.joinInfo.join_remark}!`
                    this.tipsDialogVsi = true
                }
            })
        },
        // 检测账号是否可加盟
        joinValid(){
            // firm_id: 0  个体， 非0  服务商
            // is_join：0  未加盟， 1  已加盟
            let info = this.driverInfo
            this.tipsTitle = '操作异常'
            if(this.form.mobile.length != 11){
                this.tipsText = '请输入手机号！'
                this.tipsDialogVsi = true
                return false
            }
            if(!info){
                this.tipsText = '师傅信息异常，请重新输入验证码！'
                this.tipsDialogVsi = true
                return false
            }
            if(info.firm_id){
                this.tipsText = '该账号已归属服务商，不可操作！'
                this.tipsDialogVsi = true
                return false
            }
            if(info.is_join == 1 && this.joinInfo.join_status != 2){
                this.tipsText = '该账号已加盟，不可操作！'
                this.tipsDialogVsi = true
                return false
            }
            return true
        },
        openAgree(){
            window.location.href = 'https://h5.zykjsz.com/images/xieyi/join/default.htm'
        }
    }
}
</script>

<style lang="scss" scoped>
    .view{
        min-height: 100vh;
        .imageBg{
            width: 100%;
            height: 556px;
            .bg{
                width: 100%;
                height: 100%;
            }
        }
        .infoBox{
            width: 100%;
            background: linear-gradient( 180deg, #45454D 0%, #2E3133 100%);
            .content{
                position: relative;
                top: -97px;
                .driverInfo{
                    width: 328px;
                    background: #FFFFFF;
                    border-radius: 10px;
                    margin: 0 auto;
                    padding: 16px 20px;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .hearder{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img{
                            width: 56px;
                            height: 13px;
                        }
                        .title{
                            line-height: 23px;
                            font-weight: 600;
                            font-size: 17px;
                            color: #333333;
                            margin: 0 12px;
                        }
                    }
                    .formData{
                        width: 100%;
                        .formInput{
                            margin-top: 16px;
                            background: #FFFFFF;
                            border-radius: 5px;
                            border: 1px solid #E4E4E4;
                        }
                        .codeInput{
                            margin-top: 16px;
                            display: flex;
                            .formInput{
                                margin-top: 0;
                                width: 186px;
                                margin-right: 8px;
                            }
                            .sendCode{
                                flex: 1;
                                background: var(--theme-color);
                                border-radius: 5px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 14px;
                                color: #333333;
                            }
                        }
                    }
                    .info{
                        width: 100%;
                        margin-top: 20px;
                        .titleBox{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            .titleLeft{
                                display: flex;
                                align-items: center;
                                font-weight: 400;
                                font-size: 15px;
                                color: #333333;
                                .line{
                                    width: 4px;
                                    height: 16px;
                                    background: var(--theme-color);
                                    border-radius: 2px;
                                    margin-right: 7px;
                                }
                            }
                            .titleRight{
                                display: flex;
                                align-items: center;
                                font-weight: 400;
                                font-size: 15px;
                                color: #F7AB00;
                            }
                        }
                        .contentBox{
                            margin-top: 16px;
                            .infoLi{
                                height: 20px;
                                margin-bottom: 12px;
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                font-weight: 400;
                                font-size: 14px;
                                .label{
                                    color: #666666;
                                }
                                .value{
                                    color: #333333;
                                }
                                .placeholder{
                                    color: #CCCCCC;
                                }
                            }
                            .imageList{
                                display: flex;
                                flex-wrap: wrap;
                                justify-content: space-between;
                                .imageLi{
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    font-size: 14px;
                                    color: #666666;
                                    line-height: 18px;
                                    margin-top: 12px;
                                    .img{
                                        width: 136px;
                                        height: 87px;
                                        border-radius: 5px;
                                        margin-bottom: 8px;
                                        background: #E4E4E4;
                                    }
                                }
                            }
                        }
                    }
                }
                .agreement{
                    font-size: 13px;
                    margin: 18px 0 0 12px;
                    .agreementLabel{
                        color: #999999;
                    }
                    .agreementText{
                        color: var(--theme-color);
                    }
                }
                .affirmBtn{
                    width: 351px;
                    height: 40px;
                    background: var(--theme-color);
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 600;
                    font-size: 16px;
                    color: var(--theme-btn);
                    margin: 12px auto 0;
                }
            }
        }
    }
    .tipsDialogView{
        display: flex;
        flex-direction: column;
        align-items: center;
        span{
            line-height: 22px;
            font-weight: 600;
            font-size: 16px;
            color: var(--theme-btn);
            margin: 10px auto 4px;
        }
        .tips{
            line-height: 19px;
            font-weight: 400;
            font-size: 14px;
            color: #333;
            margin: 27px auto;
            padding: 0 16px;
            box-sizing: border-box;
        }
    }
</style>